let configPromise = null;

/**
 * Carrega /config.json uma vez por sessão (runtime — ConfigMap, nginx, etc.).
 * Fallback vazio se o arquivo não existir (dev usa .env como backup).
 */
export function loadRuntimeConfig() {
  if (!configPromise) {
    configPromise = fetch("/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cache: "no-store",
    })
      .then((response) => {
        if (!response.ok) throw new Error(`config.json ${response.status}`);
        return response.json();
      })
      .catch(() => ({}));
  }
  return configPromise;
}


